<template>
  <div class="card-weekend-coll" data-aos="fade-up" data-aos-duration="900">
    <div class="card-weekend-coll-img-wrapper zoom-img-container" @click="goToWeekend('/weekends/week-end-' + weekend.slug)">
      <img :src="weekend.photo_key || 'https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg'" :alt="weekend.name" class="card-weekend-coll-img zoom-img" />
      <div class="image-gradient-bottom"></div>
      <div class="card-weekend-coll-title-overlay">
        <span class="card-weekend-coll-title merriweather-light-italic-24">{{ weekend.key_word }}</span>
      </div>
    </div>
    <div class="card-weekend-coll-content text-center mt-2">
      <div class="card-weekend-coll-type raleway-semi-p16 mb-1">{{ weekend.title }}</div>
      <a :href="'/weekends/week-end-' + weekend.slug" class="card-weekend-coll-link raleway-reg-p15">Découvrir la sélection</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cardweekendall",
  props: {
    weekend: { type: Object, required: true },
  },
  methods: {
    goToWeekend(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.card-weekend-coll {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}
.card-weekend-coll-img-wrapper {
  position: relative;
  width: 420px;
  height: 220px;
  overflow: hidden;
  border-radius: 0;
  cursor: pointer;

  .image-gradient-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
    pointer-events: none;
  }
}
.card-weekend-coll-img {
  width: 420px;
  height: 220px;
  object-fit: cover;
  display: block;
}

.card-weekend-coll-title-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 18px;
  text-align: center;
  pointer-events: none;
}
.card-weekend-coll-title {
  color: #F7F7F7;
}
.card-weekend-coll-content {
  margin-top: 18px;
}
.card-weekend-coll-type {
  text-transform: uppercase;
  color: #222;
}
.card-weekend-coll-link {
  color: #000000;
  text-decoration: underline;
  transition: color 0.2s;
}
.card-weekend-coll-link:hover {
  font-weight: 600;
}
@media (max-width: 900px) {
  .card-weekend-coll {
    max-width: 100%;
    padding: 0 4% 0 4%;
  }
  .card-weekend-coll-img-wrapper {
    height: 220px;
    width: 100%;
  }
  .card-weekend-coll-img {
    height: 220px;
    width: 100%;
  }
}
</style>
